import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { gutters } from '__app/spacing';
import { TextSpan } from '__app/typography';

export const StyledLabelWrapper = styled.div<{
  oneLineLayout?: boolean;
  oneLineHeader?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  margin-top: 15px;

  .insert-btn {
    margin: 0;
  }

  && .ProseMirror {
    ${({ oneLineLayout }) =>
      oneLineLayout
        ? css`
            padding: 2px 10px 4px;
            display: flex;
            align-items: center;
          `
        : ''}
    ${({ oneLineHeader }) =>
      oneLineHeader
        ? css`
            padding: 2px 10px 4px;
          `
        : ''}
  }
`;

export const StyledLabelRowWrapper = styled.label`
  display: flex;
  justify-content: space-between;
  margin: 12px 0 5px;
`;

export const StyledLabel = styled(TextSpan)<{ disabled?: boolean }>`
  line-height: 125%;
  color: ${(props) =>
    props.disabled
      ? 'var(--color-font-placeholder)'
      : 'var(--color-font-primary)'};
  margin-bottom: ${gutters.spacing(3, { baseline: true })}px;
`;

export const LimitLabel = styled(StyledLabel)<{ error?: boolean }>`
  ${({ error }) =>
    error
      ? css`
          color: var(--color-button-warning-hover);
        `
      : ''}
`;
